// ═══════════════════════════════════════════════════════════════════
//  ImportShopeeV39 — Import Products, tab SHOPEE (laluan Tampal Link)
//  RUPA v3.9 sahaja. Modal 3 langkah: Setup → Scrape → Review.
//
//  Webapp = pusat arahan; extension = kuli. Aliran:
//   • Setup  : tampal link Shopee + Sub ID + toggle "tukar ke link affiliate".
//   • Scrape : (1) hantar SCRAPE_TIKTOK_BATCH — NAMA mesej enjin borong sedia ada;
//              background mengesan link Shopee dan memakai pembaca Shopee
//              (extension `src/chrome/shopee/shopeeScrape.ts`). Kemajuan tiba
//              melalui SCRAPE_TIKTOK_PROGRESS / _STATUS yang sama.
//              (2) bila toggle hidup → tukar link affiliate, 5 link sepusingan
//              (SHOPEE_AFFILIATE_LINKS; peraturan padanan dalam utils/shopeeImport.js).
//   • Review : senarai hasil (READY / PENDING / gagal) + link affiliate setiap
//              produk → Simpan (LibraryView → `simpanImportShopee`).
//
//  ⚠️ Komponen KEMBAR rupa: ImportStepperV39.jsx (TikTok). Dua fail berasingan
//     dengan sengaja (keputusan user 3 Okt 2026: jangan campur TikTok dan Shopee) —
//     ubah rupa Review di satu, pertimbangkan yang satu lagi.
//  Dua laluan Setup (sama seperti TikTok: Tampal Link | Scrape Showcase):
//   • Tampal Link       — pelanggan tampal link produk.
//   • Scrape Storefront — extension buka storefront affiliate (collshp.com/<nama>),
//     pilih tab "Latest", kumpul senarai (SHOPEE_STOREFRONT_COLLECT) → pelanggan pilih
//     produk (semua bertanda secara lalai TERMASUK Sold Out; butang "Sold Out (N)"
//     membuang/memulangkan tanda semua produk Sold Out — keputusan user 3 Okt 2026).
//     Selepas itu enjin scrape + affiliate yang SAMA dengan laluan Tampal Link.
// ═══════════════════════════════════════════════════════════════════
import { useState, useEffect, useMemo, useRef } from 'react';
import { evaluateProductData } from '../services/productReadyService';
import {
    parseLinksShopee, idShopeeDariUrl, urlProdukShopee, kunciShopee,
    bersihSubId, bacaSubIdTersimpan, tulisSubIdTersimpan, bacaAutoAffiliate, tulisAutoAffiliate,
    tukarAffiliateBerkumpulan, MAKS_SUB_ID,
    urlStorefrontShopee, bilanganStorefront, sahkanProdukStorefront, LALAI_PRODUK_STOREFRONT, MAKS_PRODUK_STOREFRONT,
    kemasStorefrontTersimpan, namaDariUrlStorefront, MAKS_STOREFRONT_TERSIMPAN, MAKS_NAMA_STOREFRONT,
    buangUlasanScrape,
} from '../utils/shopeeImport';

function bridgeSend(payload) {
    const id = `ish_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    window.postMessage({ type: 'SESAAT_CHROME_BRIDGE', id, payload }, '*');
    return id;
}

function bridgeRequest(payload, timeoutMs = 120000) {
    return new Promise((resolve) => {
        const id = `ish_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
        const onMsg = (e) => {
            if (e.data?.type === 'SESAAT_CHROME_BRIDGE_RESPONSE' && e.data.id === id) {
                window.removeEventListener('message', onMsg);
                clearTimeout(tmr);
                resolve(e.data.response ?? null);
            }
        };
        const tmr = setTimeout(() => { window.removeEventListener('message', onMsg); resolve(null); }, timeoutMs);
        window.addEventListener('message', onMsg);
        window.postMessage({ type: 'SESAAT_CHROME_BRIDGE', id, payload }, '*');
    });
}

const GROUP_COLORS = ['#6366f1', '#ec4899', '#f59e0b', '#10b981', '#0ea5e9', '#8b5cf6', '#ef4444', '#64748b'];

function parseSpecLines(text) {
    const out = {};
    String(text || '').split(/\r?\n/).forEach((line) => {
        const m = line.trim().match(/^([^:：]{1,40})\s*[:：]\s*(.+)$/);
        if (m) out[m[1].trim()] = m[2].trim();
    });
    return out;
}
function parseReviewLines(text) {
    return String(text || '').split(/\r?\n/).map((l) => l.trim()).filter((l) => l.length > 2).map((l) => ({ text: l }));
}

/** URL produk kanonik bagi satu baris: dari hasil scrape, atau dari link yang ditampal. */
function urlKanonik(data, sourceUrl) {
    const id = idShopeeDariUrl(data?.resolvedUrl || '') || idShopeeDariUrl(sourceUrl || '');
    return id ? urlProdukShopee(id.shopId, id.itemId, id.domain) : '';
}

const STYLE = `
.ish-overlay{position:fixed;inset:0;background:rgba(0,0,0,.55);display:flex;align-items:center;justify-content:center;z-index:9999;padding:16px;}
.ish-modal{background:var(--s-card);color:var(--s-ink);border:1px solid var(--s-line);border-radius:16px;width:min(720px,100%);max-height:90vh;display:flex;flex-direction:column;box-shadow:var(--s-shadow-modal);overflow:hidden;}
.ish-head{display:flex;align-items:center;gap:10px;padding:16px 18px;border-bottom:1px solid var(--s-line);}
.ish-title{font-size:15px;font-weight:700;flex:1;}
.ish-x{width:30px;height:30px;border-radius:8px;border:0;background:var(--s-fill);color:var(--s-ink-2);cursor:pointer;font-size:16px;line-height:1;}
.ish-x:hover{background:var(--s-fill-hover);}
.ish-steps{display:flex;align-items:center;gap:6px;padding:12px 18px;flex-wrap:wrap;}
.ish-pill{font-size:12px;font-weight:600;padding:4px 12px;border-radius:999px;background:var(--s-fill);color:var(--s-ink-3);}
.ish-pill.on{background:var(--s-ink);color:var(--s-card);}
.ish-pill.done{background:var(--s-ok-soft,var(--s-fill));color:var(--s-ok);}
.ish-sep{color:var(--s-ink-3);font-size:13px;}
.ish-body{padding:16px 18px;overflow-y:auto;flex:1;}
.ish-modes{display:flex;gap:6px;margin-bottom:14px;}
.ish-mode{flex:1;font-size:12px;font-weight:600;padding:8px;border-radius:9px;border:1px solid var(--s-line);background:var(--s-fill);color:var(--s-ink-2);cursor:pointer;font-family:inherit;}
.ish-mode.on{background:var(--s-ink);color:var(--s-card);border-color:var(--s-ink);}
.ish-mode:disabled{opacity:.5;cursor:not-allowed;}
.ish-lbl{font-size:11px;font-weight:600;color:var(--s-ink-2);margin-bottom:5px;display:block;}
.ish-ta{width:100%;min-height:130px;background:var(--s-fill);border:1px solid var(--s-line);border-radius:10px;padding:10px 12px;color:var(--s-ink);font-size:13px;font-family:inherit;resize:vertical;box-sizing:border-box;}
.ish-ta:focus{outline:none;border-color:var(--s-ink-3);}
.ish-in{width:100%;background:var(--s-fill);border:1px solid var(--s-line);border-radius:10px;padding:9px 12px;color:var(--s-ink);font-size:13px;box-sizing:border-box;font-family:inherit;}
.ish-in:disabled{opacity:.5;}
.ish-hint{font-size:11px;color:var(--s-ink-3);margin-top:5px;line-height:1.5;}
.ish-suis{display:flex;align-items:center;gap:10px;margin-top:14px;font-size:13px;font-weight:600;color:var(--s-ink);cursor:pointer;background:transparent;border:0;padding:0;text-align:left;font-family:inherit;}
.ish-suis-trek{width:34px;height:20px;border-radius:999px;background:var(--s-line-strong,var(--s-line));position:relative;flex:none;transition:background .15s;}
.ish-suis-trek.on{background:var(--s-ink);}
.ish-suis-butang{position:absolute;top:2px;left:2px;width:16px;height:16px;border-radius:50%;background:var(--s-card);transition:left .15s;}
.ish-suis-trek.on .ish-suis-butang{left:16px;}
.ish-ext{display:flex;align-items:center;gap:7px;font-size:12px;margin-top:14px;}
.ish-dot{width:8px;height:8px;border-radius:99px;flex:none;}
.ish-note{font-size:12px;color:var(--s-ink-2);line-height:1.55;background:var(--s-fill);border-radius:10px;padding:10px 12px;margin-top:12px;}
.ish-amaran{background:var(--s-warn-soft,var(--s-fill));border:1px solid var(--s-warn);border-radius:10px;padding:10px 12px;font-size:12px;color:var(--s-ink);line-height:1.5;margin-bottom:12px;}
.ish-reconnect{display:flex;flex-direction:column;gap:9px;align-items:flex-start;background:var(--s-warn-soft,var(--s-fill));border:1px solid var(--s-warn);border-radius:10px;padding:10px 12px;margin-top:8px;font-size:12px;line-height:1.5;color:var(--s-ink);}
.ish-prog{height:8px;background:var(--s-fill);border-radius:99px;overflow:hidden;margin:10px 0;}
.ish-prog>div{height:100%;background:var(--s-ink);transition:width .3s;}
.ish-row{display:flex;align-items:center;gap:8px;font-size:12px;background:var(--s-fill);border-radius:8px;padding:7px 10px;margin-bottom:5px;}
.ish-row .nm{flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
.ish-badge{font-size:10px;font-weight:700;padding:2px 8px;border-radius:999px;white-space:nowrap;}
.ish-foot{display:flex;align-items:center;gap:10px;padding:14px 18px;border-top:1px solid var(--s-line);}
.ish-btn{font-size:13px;font-weight:600;padding:9px 18px;border-radius:10px;border:1px solid var(--s-line);background:var(--s-card);color:var(--s-ink);cursor:pointer;font-family:inherit;}
.ish-btn:hover{background:var(--s-fill);}
.ish-btn.primary{background:var(--s-ink);color:var(--s-card);border-color:var(--s-ink);}
.ish-btn.primary:hover{filter:brightness(1.08);}
.ish-btn.ok{background:var(--s-ok);color:var(--s-card);border-color:var(--s-ok);}
.ish-btn:disabled{opacity:.45;cursor:not-allowed;}
.ish-sedang{display:flex;align-items:center;gap:9px;font-size:13px;font-weight:600;color:var(--s-ink);background:var(--s-fill);border-radius:10px;padding:10px 12px;margin-bottom:10px;}
.ish-sedang .nm{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
.ish-spin{width:15px;height:15px;flex:none;border:2px solid var(--s-line-strong,var(--s-line));border-top-color:var(--s-ink);border-radius:50%;animation:ish-rot .7s linear infinite;}
@keyframes ish-rot{to{transform:rotate(360deg)}}
.ish-bulkbar{display:flex;align-items:center;gap:10px;padding:8px 10px;background:var(--s-fill);border:1px solid var(--s-line);border-radius:10px;margin-bottom:8px;flex-wrap:wrap;}
.ish-checkl{display:flex;align-items:center;gap:6px;font-size:11px;font-weight:700;color:var(--s-ink-2);cursor:pointer;}
.ish-cards{display:flex;flex-direction:column;gap:8px;max-height:340px;overflow-y:auto;margin-bottom:4px;}
.ish-card{background:var(--s-card);border:1px solid var(--s-line);border-radius:12px;padding:10px;}
.ish-card.err{background:var(--s-stop-soft,var(--s-fill));border-color:var(--s-stop);}
.ish-cardtop{display:flex;gap:10px;align-items:flex-start;}
.ish-thumb{width:52px;height:52px;object-fit:cover;border-radius:8px;background:var(--s-fill);flex:none;}
.ish-idrow{display:flex;align-items:center;gap:6px;flex-wrap:wrap;}
.ish-id{font-size:10px;font-weight:800;color:var(--s-ink-3);white-space:nowrap;}
.ish-name{font-size:12.5px;font-weight:700;color:var(--s-ink);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin-top:2px;}
.ish-meta{font-size:10.5px;color:var(--s-ink-2);margin-top:3px;font-weight:600;}
.ish-err{font-size:10.5px;color:var(--s-stop);font-weight:600;margin-top:3px;line-height:1.45;}
.ish-xrow{border:0;background:transparent;color:var(--s-stop);font-size:13px;font-weight:800;cursor:pointer;padding:2px 4px;flex:none;}
.ish-aff{display:flex;align-items:center;gap:8px;margin-top:8px;font-size:11px;background:var(--s-fill);border-radius:8px;padding:6px 10px;flex-wrap:wrap;}
.ish-aff .lk{font-weight:700;color:var(--s-ink);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex:1;min-width:0;}
.ish-aff.tiada{background:var(--s-warn-soft,var(--s-fill));border:1px solid var(--s-warn);color:var(--s-ink);}
.ish-chiprow{display:flex;gap:6px;margin-top:8px;flex-wrap:wrap;}
.ish-chip{font-size:10.5px;font-weight:800;padding:5px 10px;border-radius:7px;border:1px solid var(--s-line);background:var(--s-fill);color:var(--s-ink-2);cursor:pointer;font-family:inherit;}
.ish-chip:hover{background:var(--s-fill-hover);}
.ish-chip.gelap{color:var(--s-card);background:var(--s-ink);border-color:var(--s-ink);}
.ish-chip.stop{color:var(--s-stop);background:var(--s-stop-soft,var(--s-fill));border-color:var(--s-stop);}
.ish-chip:disabled{opacity:.5;cursor:not-allowed;}
.ish-warn{margin-top:8px;background:var(--s-warn-soft,var(--s-fill));border:1px solid var(--s-warn);border-radius:8px;padding:8px 10px;font-size:11px;color:var(--s-ink);line-height:1.5;}
.ish-gpill{width:100%;display:flex;align-items:center;gap:6px;margin-top:8px;padding:6px 10px;border-radius:8px;font-size:10.5px;font-weight:800;cursor:pointer;background:var(--s-fill);color:var(--s-ink-3);border:1px dashed var(--s-line-strong,var(--s-line));font-family:inherit;}
.ish-gpill .nm{flex:1;text-align:left;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
.ish-gmenu{background:var(--s-card);border:1px solid var(--s-line);border-radius:10px;overflow:hidden;margin-top:6px;}
.ish-gmi{width:100%;display:flex;align-items:center;gap:8px;padding:8px 10px;font-size:11px;font-weight:700;color:var(--s-ink);background:transparent;border:0;cursor:pointer;text-align:left;font-family:inherit;}
.ish-gmi:hover{background:var(--s-fill);}
.ish-gdot{width:10px;height:10px;border-radius:5px;flex:none;}
.ish-gadd{border-top:1px solid var(--s-line);padding:8px;display:flex;flex-direction:column;gap:6px;}
.ish-gcolors{display:flex;gap:4px;flex-wrap:wrap;}
.ish-gcolor{width:18px;height:18px;border-radius:9px;border:0;cursor:pointer;padding:0;}
.ish-editovl{position:fixed;inset:0;background:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;z-index:10000;}
.ish-editbox{background:var(--s-card);border:1px solid var(--s-line);border-radius:14px;max-width:420px;width:92%;max-height:86vh;display:flex;flex-direction:column;}
.ish-edithead{padding:14px 16px;border-bottom:1px solid var(--s-line);}
.ish-editbody{padding:16px;overflow-y:auto;flex:1;display:flex;flex-direction:column;gap:10px;}
.ish-editfoot{padding:12px;border-top:1px solid var(--s-line);display:flex;gap:8px;justify-content:flex-end;}
.ish-fldl{font-size:10px;font-weight:800;color:var(--s-ink-2);text-transform:uppercase;letter-spacing:.05em;display:block;margin-bottom:4px;}
.ish-toast{position:fixed;left:50%;bottom:20px;transform:translateX(-50%);z-index:10001;background:var(--s-ink);color:var(--s-card);padding:8px 16px;border-radius:10px;font-size:12px;font-weight:600;}
@media (max-width:640px){.ish-modal{max-height:96vh;}}
`;

export default function ImportShopeeV39({
    open,
    onClose,
    profiles = [],
    groups = [],
    existingKeys = null,  // Set<"shopId.itemId"> produk Shopee yang sudah ada dalam My Products
    profileId = '',       // akaun destinasi = kad profile yang sedang dibuka (baca sahaja)
    onSave,               // async ({items}) => {saved, ditolak}
    onAddGroup,           // async (name, color) => {id} | null
    tabPlatform = null,   // nod <TabPlatformImport> — dipapar di atas langkah Setup
    storefronts = [],     // storefront tersimpan pada akaun: [{id, nama, url}]
    onSaveStorefronts,    // async (senarai) => boolean — tulis `users/{uid}.shopeeStorefronts`
    t,
}) {
    const T = (k, d, v) => {
        if (!t) return d;
        const s = t(k, v);
        return (s === k) ? d : s;
    };

    const [step, setStep] = useState('setup');          // setup | scrape | review
    const [linksText, setLinksText] = useState('');
    const [extAlive, setExtAlive] = useState(null);     // null=semak, true, false
    const [extShopee, setExtShopee] = useState(null);   // extension ini faham arahan Shopee? (bendera PONG)
    const [results, setResults] = useState([]);         // {sourceUrl, status, data, error}
    const [fasa, setFasa] = useState('scrape');         // scrape | affiliate (dalam langkah Scrape)
    const [subId, setSubId] = useState(() => bacaSubIdTersimpan());
    const [autoAff, setAutoAff] = useState(() => bacaAutoAffiliate());
    const [aff, setAff] = useState({ hasil: {}, gagal: {} });   // kunci = URL produk kanonik
    const [affKemajuan, setAffKemajuan] = useState(null);       // {siap, jumlah}
    const [affSedang, setAffSedang] = useState(false);
    const [notis, setNotis] = useState('');             // batch dihentikan / ralat umum affiliate
    const [saving, setSaving] = useState(false);
    const [savedMsg, setSavedMsg] = useState('');
    const [ditolak, setDitolak] = useState([]);

    // ── Laluan Setup: 'link' (tampal) atau 'storefront' (kutip dari collshp.com) ──
    const [mod, setMod] = useState('link');
    const [sfUrl, setSfUrl] = useState('');
    const [sfMaks, setSfMaks] = useState(String(LALAI_PRODUK_STOREFRONT));
    const [sfSedang, setSfSedang] = useState(false);
    const [sfRalat, setSfRalat] = useState('');
    const [sfAmaran, setSfAmaran] = useState('');
    const [sfProduk, setSfProduk] = useState(null);          // [{kunci,url,nama,harga,soldOut}] | null
    const [sfPilih, setSfPilih] = useState(() => new Set()); // kunci produk yang ditanda
    const [sfCari, setSfCari] = useState('');
    // Storefront tersimpan (dropdown): '' = storefront baharu (belum disimpan).
    const [sfPilihId, setSfPilihId] = useState('');
    const [sfNama, setSfNama] = useState('');
    const [sfMenyimpan, setSfMenyimpan] = useState(false);
    const [sfBorang, setSfBorang] = useState('');   // '' tertutup · 'baru' · 'edit' — borang Nama + Link

    const [rowGroup, setRowGroup] = useState({});
    const [removedUrls, setRemovedUrls] = useState(() => new Set());
    const [selectedUrls, setSelectedUrls] = useState(() => new Set());
    const [dataEdits, setDataEdits] = useState({});
    const [groupMenuFor, setGroupMenuFor] = useState(null);
    const [showAddGroup, setShowAddGroup] = useState(false);
    const [newGroupName, setNewGroupName] = useState('');
    const [newGroupColor, setNewGroupColor] = useState(GROUP_COLORS[0]);
    const [savingGroup, setSavingGroup] = useState(false);
    const [sessionGroups, setSessionGroups] = useState([]);
    const [editUrl, setEditUrl] = useState(null);
    const [editFields, setEditFields] = useState({});
    const [retryingUrls, setRetryingUrls] = useState(() => new Set());
    const [rowToast, setRowToast] = useState('');

    // Cermin SEGERAK `results` — pengendali mesej (closure effect) dan langkah affiliate
    // perlu membaca nilai terkini tanpa menunggu render. Semua perubahan lalu `ubahResults`.
    const resultsRef = useRef([]);
    const hidupRef = useRef(true);
    const batalRef = useRef(false);
    const tetapanRef = useRef({ subId, autoAff });
    useEffect(() => { tetapanRef.current = { subId, autoAff }; }, [subId, autoAff]);
    useEffect(() => { hidupRef.current = true; return () => { hidupRef.current = false; }; }, []);
    const ubahResults = (fn) => {
        const baharu = fn(resultsRef.current);
        resultsRef.current = baharu;
        setResults(baharu);
    };

    // ── Semak extension aktif (SESAAT_PING/PONG) — corak sama stepper TikTok ──
    useEffect(() => {
        if (!open) return;
        let got = false;
        const timers = [];
        // PONG membawa bendera `shopeeImport` hanya dari extension yang ada robot Shopee.
        // Extension lama menjawab KOSONG kepada arahan Shopee → sekat di sini dengan ayat jelas.
        const onMsg = (e) => {
            // Melekat pada `true`: PING dihantar beberapa kali, dan pelanggan yang ada dua
            // extension SESAAT menerima dua PONG — satu yang menyokong sudah memadai.
            if (e.data?.type === 'SESAAT_PONG') { got = true; setExtAlive(true); setExtShopee((prev) => prev === true || e.data.shopeeImport === true); }
        };
        window.addEventListener('message', onMsg);
        const ping = () => { if (!got) window.postMessage({ type: 'SESAAT_PING' }, '*'); };
        ping();
        timers.push(setTimeout(ping, 900));
        timers.push(setTimeout(ping, 1800));
        timers.push(setTimeout(() => { if (!got) setExtAlive(false); }, 2800));
        return () => { window.removeEventListener('message', onMsg); timers.forEach(clearTimeout); };
    }, [open]);

    // ── Tukar link affiliate untuk senarai URL kanonik (kumpulan 5; peraturan dalam util) ──
    const jalankanAffiliate = async (urls) => {
        const senarai = Array.from(new Set(urls.filter(Boolean)));
        if (senarai.length === 0) return;
        setAffSedang(true);
        setAffKemajuan({ siap: 0, jumlah: senarai.length });
        // Buang sebab gagal lama bagi URL yang dicuba semula.
        setAff((prev) => {
            const gagal = { ...prev.gagal };
            senarai.forEach((u) => { delete gagal[u]; });
            return { hasil: prev.hasil, gagal };
        });
        const r = await tukarAffiliateBerkumpulan({
            urls: senarai,
            subId: tetapanRef.current.subId,
            hantar: (links, sid) => bridgeRequest({ type: 'SHOPEE_AFFILIATE_LINKS', links, subId: sid }, 120000),
            padaKemajuan: (k) => { if (hidupRef.current) setAffKemajuan(k); },
            patutBerhenti: () => batalRef.current || !hidupRef.current,
        });
        if (!hidupRef.current) return;
        setAff((prev) => ({ hasil: { ...prev.hasil, ...r.hasil }, gagal: { ...prev.gagal, ...r.gagal } }));
        if (r.ralatUmum) setNotis(r.ralatUmum);
        setAffSedang(false);
        setAffKemajuan(null);
    };

    // ── Batch scrape tamat → kemas baris tergantung, tukar affiliate (jika hidup), Review ──
    const selepasScrape = async (dibatalkan) => {
        // Baris yang belum sempat di-scrape (batch dihentikan) TIDAK boleh kekal berputar.
        ubahResults((prev) => prev.map((r) => (r.status === 'pending' || r.status === 'scraping')
            ? { ...r, status: 'error', error: T('importShopee.err.notReached', 'Belum sempat di-scrape — batch dihentikan. Tekan Retry.') }
            : r));
        if (dibatalkan && !batalRef.current) {
            setNotis(T('importShopee.notice.stopped', 'Scrape dihentikan awal. Semak sebab pada produk yang gagal, kemudian tekan Retry.'));
        }
        const berjaya = resultsRef.current.filter((r) => r.status === 'success' && r.data);
        if (tetapanRef.current.autoAff && berjaya.length > 0 && !batalRef.current) {
            setFasa('affiliate');
            await jalankanAffiliate(berjaya.map((r) => urlKanonik(r.data, r.sourceUrl)));
            if (!hidupRef.current) return;
        }
        setStep('review');
    };
    const selepasScrapeRef = useRef(selepasScrape);
    useEffect(() => { selepasScrapeRef.current = selepasScrape; });

    // ── Dengar kemajuan scrape (di-relay content.ts) ──
    useEffect(() => {
        if (!open || step !== 'scrape' || fasa !== 'scrape') return;
        let tamat = false;
        const onMsg = (e) => {
            const m = e.data;
            if (!m || typeof m !== 'object') return;
            if (m.type === 'SCRAPE_TIKTOK_PROGRESS') {
                // Hanya link milik batch ini — panel extension boleh menjalankan batch TikTok sendiri.
                if (!resultsRef.current.some((r) => r.sourceUrl === m.sourceUrl)) return;
                ubahResults((prev) => prev.map((r) => r.sourceUrl === m.sourceUrl
                    ? { ...r, status: m.status, data: m.data != null ? buangUlasanScrape(m.data) : r.data, error: m.error }
                    : r));
            } else if (m.type === 'SCRAPE_TIKTOK_STATUS' && (m.status === 'complete' || m.status === 'cancelled')) {
                if (tamat) return;
                tamat = true;
                selepasScrapeRef.current(m.status === 'cancelled');
            }
        };
        window.addEventListener('message', onMsg);
        return () => window.removeEventListener('message', onMsg);
    }, [open, step, fasa]);

    const { links: linksSetup, bukanShopee } = useMemo(() => parseLinksShopee(linksText), [linksText]);

    // ── Storefront: kutip senarai produk (extension buka tab, pilih Latest, scroll, pulang senarai) ──
    const kutipStorefront = async () => {
        if (sfSedang) return;
        const url = urlStorefrontShopee(sfUrl);
        if (!url) { setSfRalat(T('importShopee.sf.errUrl', 'Link storefront tidak sah. Contoh: https://collshp.com/namaanda')); return; }
        const maks = bilanganStorefront(sfMaks);
        setSfSedang(true); setSfRalat(''); setSfAmaran(''); setSfProduk(null); setSfCari('');
        const res = await bridgeRequest({ type: 'SHOPEE_STOREFRONT_COLLECT', url, maks }, 600000);
        if (!hidupRef.current) return;
        setSfSedang(false);
        if (!res) { setSfRalat(T('import.showcase.timeout', 'Tiada respons dari extension — pastikan ia aktif.')); return; }
        if (res.ok !== true) { setSfRalat(res.error || T('importShopee.sf.fail', 'Gagal mengutip produk dari storefront.')); return; }
        const senarai = sahkanProdukStorefront(res.produk).slice(0, maks);
        if (senarai.length === 0) { setSfRalat(T('importShopee.sf.empty', 'Tiada produk dijumpai dalam storefront ini.')); return; }
        if (res.sebabTamat === 'tidak-bergerak') {
            setSfAmaran(T('importShopee.sf.partial', 'Senarai storefront berhenti dimuat sebelum habis — mungkin tidak semua produk dikutip.'));
        }
        setSfProduk(senarai);
        setSfPilih(new Set(senarai.map((p) => p.kunci)));   // semua bertanda, termasuk Sold Out
    };
    // ── Storefront tersimpan: pilih dari dropdown · simpan baharu · edit · buang ──
    const sfSenarai = useMemo(() => kemasStorefrontTersimpan(storefronts), [storefronts]);
    const sfDipilih = sfSenarai.find((s) => s.id === sfPilihId) || null;
    const pilihStorefront = (id) => {
        const s = sfSenarai.find((x) => x.id === id) || null;
        setSfPilihId(s ? s.id : '');
        setSfNama(s ? s.nama : '');
        setSfUrl(s ? s.url : '');
        setSfRalat('');
    };
    const tulisStorefronts = async (senarai, mesejOk) => {
        if (!onSaveStorefronts) return false;
        setSfMenyimpan(true);
        let ok = false;
        try { ok = (await onSaveStorefronts(senarai)) === true; } catch { ok = false; }
        if (!hidupRef.current) return ok;
        setSfMenyimpan(false);
        if (ok) setRowToast(mesejOk); else setSfRalat(T('importShopee.sf.saveFail', 'Gagal menyimpan storefront — cuba lagi.'));
        return ok;
    };
    const simpanStorefront = async () => {
        if (sfMenyimpan) return;
        const url = urlStorefrontShopee(sfUrl);
        if (!url) { setSfRalat(T('importShopee.sf.errUrl', 'Link storefront tidak sah. Contoh: https://collshp.com/namaanda')); return; }
        const nama = sfNama.replace(/\s+/g, ' ').trim().slice(0, MAKS_NAMA_STOREFRONT) || namaDariUrlStorefront(url);
        // Link yang sama sudah tersimpan (pada entri LAIN) → kemas kini entri itu, jangan cipta pendua.
        const sedia = sfSenarai.find((s) => s.url.toLowerCase() === url.toLowerCase());
        const idSasaran = sfDipilih ? sfDipilih.id : (sedia ? sedia.id : '');
        let baharu;
        let idAkhir = idSasaran;
        if (idSasaran) {
            if (sedia && sedia.id !== idSasaran) { setSfRalat(T('importShopee.sf.dupUrl', 'Link storefront ini sudah tersimpan di bawah nama lain.')); return; }
            baharu = sfSenarai.map((s) => (s.id === idSasaran ? { ...s, nama, url } : s));
        } else {
            if (sfSenarai.length >= MAKS_STOREFRONT_TERSIMPAN) {
                setSfRalat(T('importShopee.sf.full', `Maksimum ${MAKS_STOREFRONT_TERSIMPAN} storefront tersimpan. Buang satu dahulu.`, { maks: MAKS_STOREFRONT_TERSIMPAN }));
                return;
            }
            idAkhir = `sf${Date.now().toString(36)}`;
            baharu = [...sfSenarai, { id: idAkhir, nama, url }];
        }
        setSfRalat('');
        const ok = await tulisStorefronts(kemasStorefrontTersimpan(baharu), T('importShopee.sf.saved', 'Storefront disimpan'));
        if (ok && hidupRef.current) { setSfPilihId(idAkhir); setSfNama(nama); setSfUrl(url); setSfBorang(''); }
    };
    const buangStorefront = async () => {
        if (sfMenyimpan || !sfDipilih) return;
        setSfRalat('');
        const ok = await tulisStorefronts(sfSenarai.filter((s) => s.id !== sfDipilih.id), T('importShopee.sf.removed', 'Storefront dibuang'));
        if (ok && hidupRef.current) { setSfPilihId(''); setSfNama(''); setSfUrl(''); setSfBorang(''); }
    };
    // Borang Nama + Link terbuka bila: "+ Storefront baharu" / Edit ditekan, atau belum ada
    // satu pun storefront tersimpan (tiada apa untuk dipilih — pelanggan mesti mengisi).
    const sfBorangBuka = sfBorang === 'baru' || (sfBorang === 'edit' && !!sfDipilih) || sfSenarai.length === 0;
    // Butang Simpan hanya hidup bila ada sesuatu untuk disimpan (baharu, atau nilai berubah).
    const sfBerubah = !sfDipilih
        ? !!sfUrl.trim()
        : (sfDipilih.url !== (urlStorefrontShopee(sfUrl) || sfUrl.trim()) || sfDipilih.nama !== sfNama.replace(/\s+/g, ' ').trim());

    const sfTapis = (sfProduk || []).filter((p) => !sfCari.trim() || p.nama.toLowerCase().includes(sfCari.trim().toLowerCase()));
    const sfSemuaTapisDipilih = sfTapis.length > 0 && sfTapis.every((p) => sfPilih.has(p.kunci));
    const sfSoldOut = (sfProduk || []).filter((p) => p.soldOut);
    const sfSoldOutDipilih = sfSoldOut.some((p) => sfPilih.has(p.kunci));
    const sfTogol = (kunci) => setSfPilih((prev) => { const n = new Set(prev); if (n.has(kunci)) n.delete(kunci); else n.add(kunci); return n; });
    const sfTogolSemuaTapis = () => setSfPilih((prev) => {
        const n = new Set(prev);
        if (sfSemuaTapisDipilih) sfTapis.forEach((p) => n.delete(p.kunci)); else sfTapis.forEach((p) => n.add(p.kunci));
        return n;
    });
    // Butang "Sold Out (N)": ada Sold Out yang bertanda → buang tanda SEMUA Sold Out;
    // tiada yang bertanda → tanda semula semuanya.
    const sfTogolSoldOut = () => setSfPilih((prev) => {
        const n = new Set(prev);
        if (sfSoldOutDipilih) sfSoldOut.forEach((p) => n.delete(p.kunci)); else sfSoldOut.forEach((p) => n.add(p.kunci));
        return n;
    });
    const urlsSetup = mod === 'link' ? linksSetup : (sfProduk || []).filter((p) => sfPilih.has(p.kunci)).map((p) => p.url);

    const startScrape = () => {
        const linksMula = urlsSetup;
        if (!linksMula.length) return;
        batalRef.current = false;
        setNotis('');
        setAff({ hasil: {}, gagal: {} });
        setRemovedUrls(new Set()); setSelectedUrls(new Set()); setDataEdits({}); setRowGroup({});
        setDitolak([]); setSavedMsg('');
        ubahResults(() => linksMula.map((u) => ({ sourceUrl: u, status: 'pending' })));
        setFasa('scrape');
        setStep('scrape');
        bridgeSend({ type: 'SCRAPE_TIKTOK_BATCH', urls: linksMula, includeKalodata: false, enableRetry: true });
    };

    const cancelScrape = () => {
        batalRef.current = true;
        if (fasa === 'scrape') {
            bridgeSend({ type: 'SCRAPE_TIKTOK_CANCEL' });
            /* ★ 2026-10-06 — JANGAN tunggu jawapan extension untuk keluar dari langkah ini (audit
               Shopee S6). Dahulu skrin hanya berpindah bila STATUS 'cancelled' tiba; extension yang
               baru di-reload / mati tidak pernah menjawab → skrin scrape tersangkut, X dimatikan,
               pelanggan terpaksa refresh dan hasil yang sudah siap hilang. Kini terus ke Review
               dengan hasil setakat ini — perangai SAMA seperti kembar TikTok (ImportStepperV39
               `cancelScrape`). `batalRef` sudah benar, jadi `selepasScrape` melangkau tukar
               affiliate; pendengar STATUS dibuang sebaik langkah bertukar, jadi jawapan lewat
               extension tidak mencetusnya kali kedua. */
            selepasScrapeRef.current(true);
        }
        // fasa affiliate: `patutBerhenti` menghentikan kumpulan seterusnya; selepasScrape sendiri ke Review.
    };

    // ── Model baris Review ──
    const rows = useMemo(() => {
        const dilihat = new Set();
        return results
            .filter((r) => !removedUrls.has(r.sourceUrl))
            .map((r) => {
                const edited = dataEdits[r.sourceUrl];
                const sd = edited || r.data || null;
                const status = edited ? 'success' : r.status;
                const kanonik = urlKanonik(sd, r.sourceUrl);
                const kunci = kunciShopee(kanonik);
                let ready = false, missing = [];
                if (status === 'success' && sd) {
                    const ev = evaluateProductData(sd, {
                        name: sd.name, imageUrl: sd.imageUrl || (sd.gallery && sd.gallery[0]) || '',
                        link: '', shopeeProductUrl: kanonik,
                    });
                    ready = ev.ready; missing = ev.missing;
                }
                // Dua link berbeza (cth link pendek + link penuh) boleh menunjuk produk SAMA.
                const duaKali = status === 'success' && !!kunci && dilihat.has(kunci);
                if (status === 'success' && kunci) dilihat.add(kunci);
                const exists = !!(existingKeys && kunci && existingKeys.has(kunci));
                return {
                    sourceUrl: r.sourceUrl, data: sd, status, error: r.error, kanonik, kunci, ready, missing, exists, duaKali,
                    group: rowGroup[r.sourceUrl] ?? null,
                    affLink: (kanonik && aff.hasil[kanonik]) || '',
                    affSebab: (kanonik && aff.gagal[kanonik]) || '',
                };
            });
    }, [results, removedUrls, dataEdits, rowGroup, existingKeys, aff]);

    // Baris yang AKAN disimpan: berjaya, ada URL kanonik, bukan pendua dalam batch ini.
    const successRows = rows.filter((r) => r.status === 'success' && r.data && r.kanonik && !r.duaKali);
    const readyCount = successRows.filter((r) => r.ready).length;
    const tiadaAff = successRows.filter((r) => !r.affLink);
    const failedCount = rows.filter((r) => r.status === 'error').length;
    const total = results.length;
    const done = results.filter((r) => r.status === 'success' || r.status === 'error').length;
    const okCount = results.filter((r) => r.status === 'success').length;
    const errCount = results.filter((r) => r.status === 'error').length;
    const currentScraping = results.find((r) => r.status === 'scraping');

    const allGroups = useMemo(() => {
        const seen = new Set((groups || []).map((g) => g.id));
        return [...(groups || []), ...sessionGroups.filter((g) => !seen.has(g.id))];
    }, [groups, sessionGroups]);
    // Sama dengan My Products (`groupsForProduct`): akaun dibuka → HANYA group milik akaun
    // itu; tiada akaun → hanya group tanpa akaun. ⚠️ KEMBAR: ImportStepperV39.jsx.
    const visibleGroups = allGroups.filter((g) => (profileId ? g.profileId === profileId : !g.profileId));
    const namaProfilDestinasi = profileId ? (profiles.find((p) => p.id === profileId)?.name || '') : '';

    const handleSave = async () => {
        if (!onSave || saving || successRows.length === 0) return;
        setSaving(true);
        setDitolak([]);
        try {
            const res = await onSave({
                items: successRows.map((r) => ({
                    data: r.data, ready: r.ready,
                    shopeeProductUrl: r.kanonik,
                    shopeeLink: r.affLink || '',
                    groupId: r.group || null,
                    pendingReason: r.ready ? null : `Data tidak lengkap: ${(r.missing || []).join(', ')}`,
                })),
            });
            const n = (res && typeof res.saved === 'number') ? res.saved : 0;
            const tolak = (res && Array.isArray(res.ditolak)) ? res.ditolak : [];
            setSavedMsg(T('importShopee.saved', `${n} produk disimpan ke My Products`, { n }));
            if (tolak.length > 0) {
                // Ada produk yang TIDAK disimpan — jangan tutup modal; pelanggan mesti nampak.
                setDitolak(tolak);
                setSaving(false);
            } else {
                setTimeout(() => { onClose?.(); }, 1200);
            }
        } catch {
            setSavedMsg(T('importShopee.saveFail', 'Gagal simpan — cuba lagi'));
            setSaving(false);
        }
    };

    // ═══════════ Review: group / buang / pilih / edit / retry / salin ═══════════
    const assignGroup = (urls, groupId) => {
        setRowGroup((prev) => { const n = { ...prev }; urls.forEach((u) => { n[u] = groupId; }); return n; });
        setGroupMenuFor(null); setShowAddGroup(false);
    };
    const removeRows = (urls) => {
        setRemovedUrls((prev) => { const n = new Set(prev); urls.forEach((u) => n.add(u)); return n; });
        setSelectedUrls((prev) => { const n = new Set(prev); urls.forEach((u) => n.delete(u)); return n; });
        setGroupMenuFor(null);
    };
    const toggleSelect = (url) => setSelectedUrls((prev) => { const n = new Set(prev); if (n.has(url)) n.delete(url); else n.add(url); return n; });
    const selectableUrls = successRows.map((r) => r.sourceUrl);
    const allSelected = selectableUrls.length > 0 && selectableUrls.every((u) => selectedUrls.has(u));
    const toggleSelectAll = () => setSelectedUrls(allSelected ? new Set() : new Set(selectableUrls));

    const createGroupInline = async (urls) => {
        const name = newGroupName.trim();
        if (!name || !onAddGroup) return;
        if (visibleGroups.some((g) => String(g.name).toLowerCase() === name.toLowerCase())) {
            setRowToast(T('import.group.dup', 'Nama group dah wujud')); return;
        }
        setSavingGroup(true);
        try {
            const res = await onAddGroup(name, newGroupColor);
            const id = res && res.id;
            if (id) {
                setSessionGroups((prev) => [...prev, { id, name, color: newGroupColor, ...(profileId ? { profileId } : {}) }]);
                assignGroup(urls, id);
                setNewGroupName(''); setNewGroupColor(GROUP_COLORS[0]); setShowAddGroup(false);
            } else {
                setRowToast(T('import.group.addFail', 'Gagal tambah group'));
            }
        } catch {
            setRowToast(T('import.group.addFail', 'Gagal tambah group'));
        } finally { setSavingGroup(false); }
    };

    const openEdit = (r) => {
        setEditUrl(r.sourceUrl);
        const d = r.data || {};
        setEditFields({
            name: d.name || '', price: d.price || '', originalPrice: d.originalPrice || '',
            discount: d.discount || '', category: d.category || '', description: d.description || '',
            imageUrl: d.imageUrl || '',
            specsText: Object.entries(d.specifications || {}).map(([k, v]) => `${k} : ${v}`).join('\n'),
            reviewsText: (Array.isArray(d.topReviews) ? d.topReviews : []).map((rv) => String(rv?.text || '').trim()).filter(Boolean).join('\n'),
        });
    };
    const saveEdit = () => {
        if (!editUrl) return;
        const f = editFields;
        if (!f.name?.trim()) { setRowToast(T('importShopee.edit.needName', 'Nama produk wajib diisi')); return; }
        if (!/^https:\/\//.test(String(f.imageUrl || '').trim())) { setRowToast(T('importShopee.edit.needImg', 'Image URL wajib bermula dengan https://')); return; }
        const base = dataEdits[editUrl] || (resultsRef.current.find((r) => r.sourceUrl === editUrl)?.data) || {};
        const kanonik = urlKanonik(base, editUrl);
        const id = idShopeeDariUrl(kanonik);
        if (!id) { setRowToast(T('importShopee.edit.noId', 'Link ini tiada ID produk — tidak boleh diisi manual')); return; }
        const data = {
            ...base, source: 'shopee', sourceUrl: editUrl, resolvedUrl: kanonik,
            productId: `${id.shopId}.${id.itemId}`, shopeeShopId: id.shopId, shopeeItemId: id.itemId,
            name: f.name.trim(), price: f.price?.trim() || undefined,
            originalPrice: f.originalPrice?.trim() || undefined, discount: f.discount?.trim() || undefined,
            category: f.category?.trim() || undefined, description: f.description?.trim() || undefined,
            imageUrl: f.imageUrl.trim(), manualEntry: true,
        };
        const specs = parseSpecLines(f.specsText || '');
        if (Object.keys(specs).length) data.specifications = specs;
        const revs = parseReviewLines(f.reviewsText || '');
        if (revs.length) data.topReviews = revs;
        setDataEdits((prev) => ({ ...prev, [editUrl]: data }));
        setEditUrl(null);
        setRowToast(T('importShopee.edit.saved', 'Produk dikemas kini'));
    };

    // Retry produk gagal — satu atau SEMUA (bulk-first). Scrape semula, kemudian tukar
    // link affiliate bagi yang baru berjaya.
    const retryUrls = (urls) => {
        const sasaran = urls.filter((u) => !retryingUrls.has(u));
        if (sasaran.length === 0) return;
        batalRef.current = false;
        setNotis('');
        setRetryingUrls((prev) => { const n = new Set(prev); sasaran.forEach((u) => n.add(u)); return n; });
        ubahResults((prev) => prev.map((r) => sasaran.includes(r.sourceUrl) ? { ...r, status: 'pending', error: undefined } : r));
        let tamat = false;
        const selesai = () => {
            if (tamat) return;
            tamat = true;
            window.removeEventListener('message', onMsg);
            clearTimeout(tmr);
            if (!hidupRef.current) return;
            ubahResults((prev) => prev.map((r) => (sasaran.includes(r.sourceUrl) && (r.status === 'pending' || r.status === 'scraping'))
                ? { ...r, status: 'error', error: T('importShopee.err.notReached', 'Belum sempat di-scrape — batch dihentikan. Tekan Retry.') }
                : r));
            setRetryingUrls((prev) => { const n = new Set(prev); sasaran.forEach((u) => n.delete(u)); return n; });
            if (tetapanRef.current.autoAff) {
                const baru = resultsRef.current
                    .filter((r) => sasaran.includes(r.sourceUrl) && r.status === 'success' && r.data)
                    .map((r) => urlKanonik(r.data, r.sourceUrl));
                if (baru.length) jalankanAffiliate(baru);
            }
        };
        const onMsg = (e) => {
            const m = e.data;
            if (!m || typeof m !== 'object') return;
            if (m.type === 'SCRAPE_TIKTOK_PROGRESS' && sasaran.includes(m.sourceUrl)) {
                ubahResults((prev) => prev.map((r) => r.sourceUrl === m.sourceUrl
                    ? { ...r, status: m.status, data: m.data != null ? buangUlasanScrape(m.data) : r.data, error: m.error } : r));
            } else if (m.type === 'SCRAPE_TIKTOK_STATUS' && (m.status === 'complete' || m.status === 'cancelled')) {
                selesai();
            }
        };
        const tmr = setTimeout(selesai, Math.max(180000, sasaran.length * 120000));
        window.addEventListener('message', onMsg);
        bridgeSend({ type: 'SCRAPE_TIKTOK_BATCH', urls: sasaran, includeKalodata: false, enableRetry: true });
    };

    const copyText = async (txt, okMsg) => {
        try { await navigator.clipboard.writeText(txt); setRowToast(okMsg); }
        catch { setRowToast(T('import.copyFail', 'Gagal salin')); }
    };

    useEffect(() => { if (!rowToast) return; const t2 = setTimeout(() => setRowToast(''), 2400); return () => clearTimeout(t2); }, [rowToast]);

    if (!open) return null;

    const badge = (bg, ink, txt) => <span className="ish-badge" style={{ background: bg, color: ink }}>{txt}</span>;
    const sibuk = step === 'scrape' || sfSedang;
    const extLama = extAlive === true && extShopee === false;   // extension hidup tetapi tiada robot Shopee
    const extTakSedia = extAlive === false || extLama;
    const failedUrls = rows.filter((r) => r.status === 'error').map((r) => r.sourceUrl);

    const groupMenu = (urls) => (
        <div className="ish-gmenu">
            <button className="ish-gmi" onClick={() => assignGroup(urls, null)}>{T('import.group.none', 'Tiada Group')}</button>
            {visibleGroups.map((g) => (
                <button key={g.id} className="ish-gmi" onClick={() => assignGroup(urls, g.id)}>
                    <span className="ish-gdot" style={{ background: g.color }} />
                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{g.name}</span>
                </button>
            ))}
            {visibleGroups.length === 0 && (
                <div style={{ padding: '6px 10px', fontSize: 11, color: 'var(--s-ink-3)', fontStyle: 'italic' }}>{profileId
                    ? T('import.group.noneForProfile', 'Akaun ini belum ada group')
                    : T('import.group.pickProfile', 'Pilih akaun dahulu untuk group khas akaun')}</div>
            )}
            {onAddGroup && (
                <div className="ish-gadd">
                    {!showAddGroup ? (
                        <button className="ish-chip" onClick={() => setShowAddGroup(true)}>+ {T('import.group.new', 'Group Baru')}</button>
                    ) : (
                        <>
                            <input className="ish-in" style={{ padding: '6px 8px', fontSize: 11 }} value={newGroupName} onChange={(e) => setNewGroupName(e.target.value)} placeholder={T('import.group.name', 'Nama group')} autoFocus />
                            <div className="ish-gcolors">
                                {GROUP_COLORS.map((c) => (
                                    <button key={c} className="ish-gcolor" aria-label={c} style={{ background: c, outline: newGroupColor === c ? '2px solid var(--s-ink)' : '2px solid transparent' }} onClick={() => setNewGroupColor(c)} />
                                ))}
                            </div>
                            <div style={{ display: 'flex', gap: 6 }}>
                                <button className="ish-btn primary" style={{ flex: 1, padding: '6px 8px', fontSize: 11 }} disabled={savingGroup || !newGroupName.trim()} onClick={() => createGroupInline(urls)}>
                                    {savingGroup ? T('import.group.saving', 'Menyimpan…') : T('import.group.saveUse', 'Simpan & Guna')}
                                </button>
                                <button className="ish-btn" style={{ padding: '6px 8px', fontSize: 11 }} onClick={() => { setShowAddGroup(false); setNewGroupName(''); }}>{T('import.cancel', 'Batal')}</button>
                            </div>
                        </>
                    )}
                </div>
            )}
        </div>
    );

    return (
        <div className="ish-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget && !sibuk) onClose?.(); }}>
            <style>{STYLE}</style>
            <div className="ish-modal">
                <div className="ish-head">
                    <span className="ish-title">{T('import.title', 'Import Produk')}</span>
                    {!sibuk && <button className="ish-x" onClick={() => onClose?.()} aria-label={T('importShopee.close', 'Tutup')}>✕</button>}
                </div>

                <div className="ish-steps">
                    <span className={`ish-pill ${step === 'setup' ? 'on' : 'done'}`}>1 · {T('import.step.setup', 'Setup')}</span>
                    <span className="ish-sep">›</span>
                    <span className={`ish-pill ${step === 'scrape' ? 'on' : (step === 'review' ? 'done' : '')}`}>2 · {T('import.step.scrape', 'Scrape')}</span>
                    <span className="ish-sep">›</span>
                    <span className={`ish-pill ${step === 'review' ? 'on' : ''}`}>3 · {T('import.step.review', 'Review')}</span>
                </div>

                <div className="ish-body">
                    {/* ── LANGKAH 1: SETUP ── */}
                    {step === 'setup' && (
                        <>
                            {tabPlatform}

                            {/* Pilih laluan: Tampal Link atau Scrape Storefront */}
                            <div className="ish-modes">
                                <button type="button" className={`ish-mode${mod === 'link' ? ' on' : ''}`} disabled={sfSedang} onClick={() => setMod('link')}>
                                    {T('import.mode.link', 'Tampal Link')}
                                </button>
                                <button type="button" className={`ish-mode${mod === 'storefront' ? ' on' : ''}`} disabled={sfSedang} onClick={() => setMod('storefront')}>
                                    {T('importShopee.mode.storefront', 'Scrape Storefront')}
                                </button>
                            </div>

                            {mod === 'link' && (
                                <>
                                    <label className="ish-lbl" htmlFor="ish-links">{T('importShopee.setup.linksLabel', 'Tampal link produk Shopee (satu atau banyak)')}</label>
                                    <textarea
                                        id="ish-links"
                                        className="ish-ta"
                                        value={linksText}
                                        onChange={(e) => setLinksText(e.target.value)}
                                        placeholder={'https://shopee.com.my/Nama-Produk-i.123456789.12345678901\nhttps://s.shopee.com.my/…\nhttps://shopee.sg/… (Singapura)'}
                                    />
                                    {bukanShopee > 0 && (
                                        <div className="ish-hint" style={{ color: 'var(--s-warn)' }}>
                                            {T('importShopee.setup.skipped', `${bukanShopee} link diabaikan — bukan halaman produk Shopee Malaysia.`, { n: bukanShopee })}
                                        </div>
                                    )}
                                </>
                            )}

                            {mod === 'storefront' && !sfProduk && (
                                <>
                                    {/* Storefront tersimpan — pilih dari dropdown. Borang Nama + Link HANYA dibuka bila
                                        pelanggan memilih "+ Storefront baharu" atau menekan Edit (arahan user 3 Okt);
                                        bila belum ada satu pun storefront tersimpan, borang terus terbuka. */}
                                    <label className="ish-lbl" htmlFor="ish-sfpilih">{T('importShopee.sf.savedLabel', 'Storefront tersimpan')}</label>
                                    <select
                                        id="ish-sfpilih"
                                        className="ish-in"
                                        value={sfBorang === 'baru' ? '__baru__' : (sfDipilih ? sfDipilih.id : '')}
                                        disabled={sfSedang || sfMenyimpan}
                                        onChange={(e) => {
                                            const v = e.target.value;
                                            if (v === '__baru__') { pilihStorefront(''); setSfBorang('baru'); } else { pilihStorefront(v); setSfBorang(''); }
                                        }}
                                    >
                                        <option value="">{T('importShopee.sf.pickPh', 'Pilih storefront…')}</option>
                                        {sfSenarai.map((s) => <option key={s.id} value={s.id}>{s.nama}</option>)}
                                        <option value="__baru__">{T('importShopee.sf.newOption', '+ Storefront baharu')}</option>
                                    </select>

                                    {/* Storefront tersimpan dipilih + borang tertutup → papar linknya sahaja, dengan Edit / Buang. */}
                                    {sfDipilih && !sfBorangBuka && (
                                        <div className="ish-aff" style={{ marginTop: 8 }}>
                                            <span className="lk" style={{ fontWeight: 600 }}>{sfDipilih.url}</span>
                                            {onSaveStorefronts && (
                                                <>
                                                    <button type="button" className="ish-chip" disabled={sfSedang || sfMenyimpan} onClick={() => setSfBorang('edit')}>{T('importShopee.sf.edit', 'Edit')}</button>
                                                    <button type="button" className="ish-chip stop" disabled={sfSedang || sfMenyimpan} onClick={buangStorefront}>{T('importShopee.sf.remove', 'Buang dari senarai')}</button>
                                                </>
                                            )}
                                        </div>
                                    )}

                                    {sfBorangBuka && (<>
                                    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1fr) minmax(0,2fr)', gap: 10, marginTop: 12 }}>
                                        <div>
                                            <label className="ish-lbl" htmlFor="ish-sfnama">{T('importShopee.sf.nameLabel', 'Nama')}</label>
                                            <input
                                                id="ish-sfnama"
                                                className="ish-in"
                                                value={sfNama}
                                                maxLength={MAKS_NAMA_STOREFRONT}
                                                disabled={sfSedang || sfMenyimpan}
                                                onChange={(e) => setSfNama(e.target.value)}
                                                placeholder={T('importShopee.sf.namePh', 'cth: Kedai utama')}
                                            />
                                        </div>
                                        <div>
                                            <label className="ish-lbl" htmlFor="ish-sfurl">{T('importShopee.sf.urlLabel', 'Link storefront')}</label>
                                            <input
                                                id="ish-sfurl"
                                                className="ish-in"
                                                value={sfUrl}
                                                disabled={sfSedang || sfMenyimpan}
                                                onChange={(e) => { setSfUrl(e.target.value); setSfRalat(''); }}
                                                placeholder="https://collshp.com/namaanda"
                                            />
                                        </div>
                                    </div>
                                    {onSaveStorefronts && (
                                        <div className="ish-chiprow">
                                            <button type="button" className="ish-chip" disabled={sfSedang || sfMenyimpan || !sfBerubah} onClick={simpanStorefront}>
                                                {sfMenyimpan ? T('import.saving', 'Menyimpan…')
                                                    : sfDipilih ? T('importShopee.sf.saveEdit', 'Simpan perubahan')
                                                        : T('importShopee.sf.saveNew', 'Simpan storefront ini')}
                                            </button>
                                            {/* Batal hanya bila ada storefront tersimpan untuk dipatah balik kepadanya. */}
                                            {sfSenarai.length > 0 && (
                                                <button type="button" className="ish-chip" disabled={sfSedang || sfMenyimpan}
                                                    onClick={() => { pilihStorefront(sfDipilih ? sfDipilih.id : ''); setSfBorang(''); }}>
                                                    {T('import.cancel', 'Batal')}
                                                </button>
                                            )}
                                        </div>
                                    )}
                                    </>)}
                                    <div style={{ marginTop: 12, maxWidth: 280 }}>
                                        <label className="ish-lbl" htmlFor="ish-sfmaks">{T('importShopee.sf.maksLabel', 'Bilangan produk (terbaru dahulu)')}</label>
                                        <input
                                            id="ish-sfmaks"
                                            className="ish-in"
                                            type="number" min="1" max={MAKS_PRODUK_STOREFRONT}
                                            value={sfMaks}
                                            disabled={sfSedang}
                                            onChange={(e) => setSfMaks(e.target.value)}
                                        />
                                        <div className="ish-hint">{T('importShopee.sf.maksHint', `Produk dikutip ikut susunan "Latest" storefront. Maksimum ${MAKS_PRODUK_STOREFRONT}.`, { maks: MAKS_PRODUK_STOREFRONT })}</div>
                                    </div>
                                    <button type="button" className="ish-btn primary" style={{ marginTop: 12, display: 'inline-flex', alignItems: 'center', gap: 8 }}
                                        disabled={sfSedang || extTakSedia || !sfUrl.trim()} onClick={kutipStorefront}>
                                        {sfSedang && <span className="ish-spin" style={{ borderColor: 'rgba(255,255,255,.35)', borderTopColor: 'var(--s-card)' }} />}
                                        {sfSedang
                                            ? T('importShopee.sf.collecting', 'Mengutip produk dari storefront…')
                                            : T('importShopee.sf.collect', 'Kutip dari Storefront')}
                                    </button>
                                    {sfSedang && <div className="ish-hint">{T('importShopee.sf.wait', 'Extension sedang membuka storefront dan scroll senarai produk. Ini boleh mengambil masa 1–2 minit — jangan tutup tab itu.')}</div>}
                                    {sfRalat && <div className="ish-amaran" style={{ marginTop: 12, marginBottom: 0 }}>{sfRalat}</div>}
                                </>
                            )}

                            {mod === 'storefront' && sfProduk && (
                                <>
                                    {sfAmaran && <div className="ish-amaran">{sfAmaran}</div>}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
                                        <input className="ish-in" style={{ flex: 1, minWidth: 160 }} placeholder={T('import.showcase.search', 'Cari nama produk…')} value={sfCari} onChange={(e) => setSfCari(e.target.value)} />
                                        <button type="button" className="ish-btn" style={{ padding: '8px 12px' }} onClick={sfTogolSemuaTapis}>
                                            {sfSemuaTapisDipilih ? T('import.showcase.none', 'Nyahpilih') : T('import.showcase.all', 'Pilih semua')}
                                        </button>
                                        {sfSoldOut.length > 0 && (
                                            <button type="button" className={`ish-btn${sfSoldOutDipilih ? '' : ' primary'}`} style={{ padding: '8px 12px' }} aria-pressed={!sfSoldOutDipilih}
                                                title={sfSoldOutDipilih
                                                    ? T('importShopee.sf.soldOutTipOff', 'Buang tanda semua produk Sold Out')
                                                    : T('importShopee.sf.soldOutTipOn', 'Tanda semula semua produk Sold Out')}
                                                onClick={sfTogolSoldOut}>
                                                {T('importShopee.sf.soldOutBtn', `Sold Out (${sfSoldOut.length})`, { n: sfSoldOut.length })}
                                            </button>
                                        )}
                                    </div>
                                    <div style={{ maxHeight: 240, overflowY: 'auto' }}>
                                        {sfTapis.map((p) => (
                                            <label className="ish-row" key={p.kunci} style={{ cursor: 'pointer' }}>
                                                <input type="checkbox" checked={sfPilih.has(p.kunci)} onChange={() => sfTogol(p.kunci)} />
                                                <span className="nm" style={p.soldOut ? { color: 'var(--s-ink-3)' } : undefined}>{p.nama}</span>
                                                {p.soldOut && <span className="ish-badge" style={{ background: 'var(--s-card)', color: 'var(--s-ink-2)', border: '1px solid var(--s-line)' }}>Sold Out</span>}
                                                {p.harga && <span style={{ fontSize: 11, color: 'var(--s-ink-2)', whiteSpace: 'nowrap' }}>{p.harga}</span>}
                                            </label>
                                        ))}
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 6 }}>
                                        <span style={{ flex: 1, fontSize: 12, color: 'var(--s-ink-2)' }}>
                                            {T('import.showcase.selected', `${sfPilih.size} dipilih daripada ${sfProduk.length}`, { n: sfPilih.size, total: sfProduk.length })}
                                        </span>
                                        <button type="button" className="ish-chip" onClick={() => { setSfProduk(null); setSfPilih(new Set()); setSfAmaran(''); }}>{T('importShopee.sf.again', 'Kutip semula')}</button>
                                    </div>
                                </>
                            )}

                            <button type="button" className="ish-suis" role="switch" aria-checked={autoAff}
                                onClick={() => { const v = !autoAff; setAutoAff(v); tulisAutoAffiliate(v); }}>
                                <span className={`ish-suis-trek${autoAff ? ' on' : ''}`}><span className="ish-suis-butang" /></span>
                                {T('importShopee.setup.autoAff', 'Tukar ke link affiliate secara automatik')}
                            </button>

                            <div style={{ marginTop: 12, maxWidth: 280 }}>
                                <label className="ish-lbl" htmlFor="ish-subid">{T('importShopee.setup.subId', 'Sub ID')}</label>
                                <input
                                    id="ish-subid"
                                    className="ish-in"
                                    value={subId}
                                    maxLength={MAKS_SUB_ID}
                                    disabled={!autoAff}
                                    onChange={(e) => { const v = bersihSubId(e.target.value); setSubId(v); tulisSubIdTersimpan(v); }}
                                    placeholder="sesaat"
                                />
                                <div className="ish-hint">{T('importShopee.setup.subIdHint', 'Huruf dan nombor sahaja. Sub ID membantu anda menjejak klik dalam laporan Shopee Affiliate.')}</div>
                            </div>

                            <div className="ish-ext">
                                <span className="ish-dot" style={{ background: extAlive === true ? 'var(--s-ok)' : extAlive === false ? 'var(--s-stop)' : 'var(--s-ink-3)' }} />
                                <span style={{ color: 'var(--s-ink-2)' }}>
                                    {extAlive === true ? T('import.ext.on', 'Extension SESAAT aktif')
                                        : extAlive === false ? T('import.ext.off', 'Extension belum bersambung.')
                                            : T('import.ext.check', 'Menyemak extension…')}
                                </span>
                            </div>
                            {extAlive === false && (
                                <div className="ish-reconnect">
                                    <span>{T('import.ext.reconnect', 'Klik butang di bawah untuk sambung.')}</span>
                                    <button className="ish-btn primary" onClick={() => window.location.reload()}>{T('import.ext.refreshBtn', 'Refresh halaman')}</button>
                                </div>
                            )}
                            {extLama && (
                                <div className="ish-amaran" style={{ marginTop: 8, marginBottom: 0 }}>
                                    {T('importShopee.ext.old', 'Extension anda belum menyokong import Shopee. Sila pasang versi extension yang terbaru, kemudian refresh halaman ini.')}
                                </div>
                            )}
                            <div className="ish-note">
                                {autoAff
                                    ? T('importShopee.setup.noteAff', 'Extension akan membuka setiap halaman produk dalam browser ini, kemudian menukar link di Shopee Affiliate. Pastikan anda sudah log masuk Shopee dan Shopee Affiliate (akaun affiliate yang diluluskan).')
                                    : T('importShopee.setup.note', 'Extension akan membuka setiap halaman produk dalam browser ini. Pastikan anda sudah log masuk Shopee.')}
                            </div>
                        </>
                    )}

                    {/* ── LANGKAH 2: SCRAPE (+ tukar link affiliate) ── */}
                    {step === 'scrape' && (
                        <>
                            <div className="ish-sedang">
                                <span className="ish-spin" />
                                <span className="nm">
                                    {fasa === 'affiliate'
                                        ? T('importShopee.aff.running', `Menukar link affiliate… ${affKemajuan?.siap || 0} / ${affKemajuan?.jumlah || 0}`, { siap: affKemajuan?.siap || 0, jumlah: affKemajuan?.jumlah || 0 })
                                        : currentScraping
                                            ? `${T('import.scrape.now', 'Sedang scrape: ')}${currentScraping.data?.name || currentScraping.sourceUrl}`
                                            : (done < total ? T('import.scrape.starting', 'Menyambung ke extension…') : T('import.scrape.finishing', 'Menyelesaikan…'))}
                                </span>
                            </div>
                            <div style={{ fontSize: 22, fontWeight: 700 }}>
                                {done}<span style={{ fontSize: 13, color: 'var(--s-ink-3)', fontWeight: 500 }}> / {total}</span>
                            </div>
                            <div className="ish-prog"><div style={{ width: total ? `${Math.round(done / total * 100)}%` : '0%' }} /></div>
                            <div style={{ fontSize: 12, color: 'var(--s-ink-2)' }}>
                                {okCount} {T('import.scrape.ok', 'siap')} · {errCount} {T('import.scrape.fail', 'gagal')}
                            </div>
                            <div style={{ marginTop: 12, maxHeight: 220, overflowY: 'auto' }}>
                                {results.map((r) => (
                                    <div className="ish-row" key={r.sourceUrl}>
                                        <span className="nm">{r.data?.name || r.sourceUrl}</span>
                                        {r.status === 'success' ? badge('var(--s-ok-soft,var(--s-fill))', 'var(--s-ok)', T('importShopee.row.ok', 'Siap'))
                                            : r.status === 'error' ? badge('var(--s-stop-soft,var(--s-fill))', 'var(--s-stop)', T('importShopee.row.fail', 'Gagal'))
                                                : r.status === 'scraping' ? badge('var(--s-fill)', 'var(--s-ink-2)', '…')
                                                    : badge('var(--s-fill)', 'var(--s-ink-3)', '·')}
                                    </div>
                                ))}
                            </div>
                        </>
                    )}

                    {/* ── LANGKAH 3: REVIEW ── */}
                    {step === 'review' && (
                        <>
                            {notis && <div className="ish-amaran">{notis}</div>}

                            <div style={{ fontSize: 13, color: 'var(--s-ink-2)', marginBottom: 10 }}>
                                {T('import.review.summary', `${successRows.length} produk berjaya (${readyCount} READY). ${failedCount} gagal.`, { ok: successRows.length, ready: readyCount, fail: failedCount })}
                            </div>

                            {/* Tindakan borong — satu klik untuk semua (bulk-first) */}
                            {(failedUrls.length > 0 || tiadaAff.length > 0) && (
                                <div className="ish-chiprow" style={{ marginTop: 0, marginBottom: 8 }}>
                                    {failedUrls.length > 0 && (
                                        <button className="ish-chip gelap" disabled={extTakSedia || retryingUrls.size > 0 || affSedang} onClick={() => retryUrls(failedUrls)}>
                                            {T('importShopee.bulk.retry', `Retry semua yang gagal (${failedUrls.length})`, { n: failedUrls.length })}
                                        </button>
                                    )}
                                    {tiadaAff.length > 0 && (
                                        <button className="ish-chip gelap" disabled={extTakSedia || affSedang || retryingUrls.size > 0} onClick={() => { setNotis(''); batalRef.current = false; jalankanAffiliate(tiadaAff.map((r) => r.kanonik)); }}>
                                            {affSedang
                                                ? T('importShopee.aff.running', `Menukar link affiliate… ${affKemajuan?.siap || 0} / ${affKemajuan?.jumlah || 0}`, { siap: affKemajuan?.siap || 0, jumlah: affKemajuan?.jumlah || 0 })
                                                : T('importShopee.bulk.aff', `Tukar link affiliate (${tiadaAff.length})`, { n: tiadaAff.length })}
                                        </button>
                                    )}
                                </div>
                            )}

                            {successRows.length > 0 && (
                                <div className="ish-bulkbar">
                                    <label className="ish-checkl">
                                        <input type="checkbox" checked={allSelected} onChange={toggleSelectAll} />
                                        {selectedUrls.size > 0 ? T('import.bulk.n', `${selectedUrls.size} dipilih`, { n: selectedUrls.size }) : T('import.bulk.all', 'Pilih semua')}
                                    </label>
                                    {selectedUrls.size > 0 && (
                                        <div style={{ marginLeft: 'auto', display: 'flex', gap: 6 }}>
                                            <button className="ish-chip gelap" onClick={() => { setGroupMenuFor(groupMenuFor === '__bulk__' ? null : '__bulk__'); setShowAddGroup(false); }}>{T('import.bulk.move', 'Masuk Group')}</button>
                                            <button className="ish-chip stop" onClick={() => removeRows(Array.from(selectedUrls))}>{T('import.bulk.remove', 'Buang')}</button>
                                        </div>
                                    )}
                                </div>
                            )}
                            {groupMenuFor === '__bulk__' && <div style={{ marginBottom: 8 }}>{groupMenu(Array.from(selectedUrls))}</div>}

                            <div className="ish-cards">
                                {rows.length === 0 && <div className="ish-note" style={{ marginTop: 0 }}>{T('import.review.empty', 'Tiada hasil. Balik ke Setup untuk mula.')}</div>}
                                {rows.map((r) => {
                                    const grp = allGroups.find((g) => g.id === r.group);
                                    const isErr = r.status === 'error';
                                    const isBusy = r.status === 'scraping' || r.status === 'pending' || retryingUrls.has(r.sourceUrl);
                                    const img = r.data?.imageUrl || (Array.isArray(r.data?.gallery) && r.data.gallery[0]) || '';
                                    const bolehSimpan = r.status === 'success' && !r.duaKali && !!r.kanonik;
                                    return (
                                        <div className={`ish-card${isErr ? ' err' : ''}`} key={r.sourceUrl}>
                                            <div className="ish-cardtop">
                                                {!isBusy && <input type="checkbox" checked={selectedUrls.has(r.sourceUrl)} onChange={() => toggleSelect(r.sourceUrl)} disabled={!bolehSimpan} style={{ marginTop: 4 }} />}
                                                {img ? <img src={img} alt="" className="ish-thumb" onError={(e) => { e.target.style.visibility = 'hidden'; }} />
                                                    : <div className="ish-thumb" />}
                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                    <div className="ish-idrow">
                                                        <span className="ish-id" title={T('importShopee.card.idTip', 'ID produk Shopee (kedai.produk)')}>#{r.kunci || '—'}</span>
                                                        {r.exists && badge('var(--s-fill)', 'var(--s-ink-3)', T('import.review.exists', 'DAH ADA'))}
                                                        {r.duaKali && badge('var(--s-fill)', 'var(--s-ink-3)', T('importShopee.card.dup', 'PRODUK SAMA'))}
                                                        {bolehSimpan && (r.ready ? badge('var(--s-ok-soft,var(--s-fill))', 'var(--s-ok)', 'READY') : badge('var(--s-warn-soft,var(--s-fill))', 'var(--s-warn)', 'PENDING'))}
                                                        {isBusy && <span style={{ fontSize: 11, color: 'var(--s-ink-3)', fontWeight: 600 }}>{T('import.card.scraping', 'Scraping…')}</span>}
                                                    </div>
                                                    <div className="ish-name">{r.data?.name || <span style={{ color: 'var(--s-ink-3)', fontWeight: 500 }}>{r.sourceUrl}</span>}</div>
                                                    {isErr ? (
                                                        <div className="ish-err">{r.error || T('import.card.failed', 'Scrape gagal')}</div>
                                                    ) : r.status === 'success' && (
                                                        <div className="ish-meta">
                                                            {T('import.card.price', 'Harga')} <b>{r.data?.price || '—'}</b>
                                                            {r.data?.discount ? <> · <b>{r.data.discount}</b></> : null}
                                                            {r.data?.soldCount ? <> · {r.data.soldCount} {T('importShopee.card.sold', 'terjual')}</> : null}
                                                        </div>
                                                    )}
                                                </div>
                                                {!isBusy && <button className="ish-xrow" title={T('import.card.remove', 'Buang produk ni')} aria-label={T('import.card.remove', 'Buang produk ni')} onClick={() => removeRows([r.sourceUrl])}>✕</button>}
                                            </div>

                                            {r.duaKali && (
                                                <div className="ish-warn">{T('importShopee.card.dupNote', 'Link ini menunjuk produk yang sama dengan baris lain — ia tidak akan disimpan dua kali.')}</div>
                                            )}

                                            {bolehSimpan && (r.affLink ? (
                                                <div className="ish-aff">
                                                    <span style={{ color: 'var(--s-ink-2)', fontWeight: 700 }}>{T('importShopee.card.aff', 'Link affiliate')}</span>
                                                    <span className="lk">{r.affLink}</span>
                                                    <button className="ish-chip" onClick={() => copyText(r.affLink, T('importShopee.copy.aff', 'Link affiliate disalin'))}>{T('importShopee.copy.btn', 'Salin')}</button>
                                                </div>
                                            ) : (
                                                <div className="ish-aff tiada">
                                                    <span style={{ flex: 1 }}>
                                                        <b>{T('importShopee.card.affNone', 'Link affiliate belum ada.')}</b>{' '}
                                                        {r.affSebab || (autoAff ? '' : T('importShopee.card.affOff', 'Toggle tukar automatik dimatikan.'))}
                                                    </span>
                                                </div>
                                            ))}

                                            {bolehSimpan && (
                                                <div className="ish-chiprow">
                                                    <button className="ish-chip" onClick={() => copyText(r.kanonik, T('import.copy.view', 'Link produk disalin'))}>{T('import.copy.viewBtn', 'Link produk')}</button>
                                                    <button className="ish-chip" onClick={() => openEdit(r)}>{T('importShopee.card.edit', 'Edit data')}</button>
                                                </div>
                                            )}

                                            {isErr && !isBusy && (
                                                <div className="ish-chiprow">
                                                    {r.kanonik && <button className="ish-chip" onClick={() => openEdit(r)}>{T('import.card.edit', 'Edit Manual')}</button>}
                                                    <button className="ish-chip gelap" disabled={extTakSedia || affSedang} onClick={() => retryUrls([r.sourceUrl])}>{T('import.card.retry', 'Retry')}</button>
                                                </div>
                                            )}

                                            {bolehSimpan && !r.ready && (
                                                <div className="ish-warn">
                                                    <div style={{ fontWeight: 700 }}>{T('import.card.pendingWarn', 'Data tak cukup — akan simpan sebagai PENDING')}</div>
                                                    <div style={{ marginTop: 2 }}>{T('import.card.stillNeed', 'Masih perlu')}: {(r.missing || []).join(', ')}</div>
                                                </div>
                                            )}

                                            {bolehSimpan && (
                                                <>
                                                    <button className="ish-gpill" style={grp ? { background: grp.color, color: '#fff', borderColor: 'transparent', borderStyle: 'solid' } : undefined}
                                                        onClick={() => { setGroupMenuFor(groupMenuFor === r.sourceUrl ? null : r.sourceUrl); setShowAddGroup(false); }}>
                                                        <span className="nm">{grp ? grp.name : T('import.group.pick', 'Pilih Group')}</span>
                                                        <span style={{ opacity: .7 }}>{groupMenuFor === r.sourceUrl ? '▴' : '▾'}</span>
                                                    </button>
                                                    {groupMenuFor === r.sourceUrl && groupMenu([r.sourceUrl])}
                                                </>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>

                            <div className="ish-note" style={{ marginTop: 12 }}>
                                {namaProfilDestinasi
                                    ? T('import.review.dest', `Produk akan disimpan ke akaun: ${namaProfilDestinasi}`, { nama: namaProfilDestinasi })
                                    : T('import.review.destNone', 'Produk akan disimpan tanpa akaun — ia duduk dalam "Semua produk". Buka satu kad akaun dahulu kalau mahu ia terus masuk ke akaun itu.')}
                            </div>

                            {savedMsg && <div className="ish-note" style={{ marginTop: 12 }}>{savedMsg}</div>}
                            {ditolak.length > 0 && (
                                <div className="ish-amaran" style={{ marginTop: 12, marginBottom: 0 }}>
                                    <b>{T('importShopee.save.rejected', `${ditolak.length} produk TIDAK disimpan:`, { n: ditolak.length })}</b>
                                    {ditolak.slice(0, 8).map((d, i) => <div key={i}>{String(d?.nama || '').slice(0, 60)} — {d?.sebab}</div>)}
                                </div>
                            )}
                        </>
                    )}
                </div>

                <div className="ish-foot">
                    {step === 'setup' && (
                        <>
                            <div style={{ flex: 1, fontSize: 12, color: 'var(--s-ink-3)' }}>
                                {mod === 'link'
                                    ? `${urlsSetup.length} ${T('import.setup.count', 'link dikesan')}`
                                    : `${urlsSetup.length} ${T('import.showcase.chosen', 'produk dipilih')}`}
                            </div>
                            <button className="ish-btn" disabled={sfSedang} onClick={() => onClose?.()}>{T('import.cancel', 'Batal')}</button>
                            <button className="ish-btn primary" disabled={urlsSetup.length === 0 || extTakSedia || sfSedang} onClick={startScrape}>
                                {T('import.start', 'Mula scrape')} →
                            </button>
                        </>
                    )}
                    {step === 'scrape' && (
                        <>
                            <div style={{ flex: 1, fontSize: 12, color: 'var(--s-ink-3)' }}>{T('import.scrape.running', 'Extension sedang bekerja…')}</div>
                            <button className="ish-btn" onClick={cancelScrape}>{T('import.scrape.stop', 'Berhenti')}</button>
                        </>
                    )}
                    {step === 'review' && (
                        <>
                            <button className="ish-btn" disabled={saving || affSedang || retryingUrls.size > 0} onClick={() => { setStep('setup'); setSavedMsg(''); setDitolak([]); }}>{T('import.review.back', '← Import lagi')}</button>
                            <div style={{ flex: 1 }} />
                            <button className="ish-btn ok" disabled={saving || affSedang || retryingUrls.size > 0 || successRows.length === 0} onClick={handleSave}>
                                {saving ? T('import.saving', 'Menyimpan…') : T('importShopee.save', `Simpan ${successRows.length} produk`, { n: successRows.length })}
                            </button>
                        </>
                    )}
                </div>
            </div>

            {/* ── Modal Edit data (isi/betulkan data produk) ── */}
            {editUrl && (() => {
                const prev = evaluateProductData(
                    { description: editFields.description },
                    { name: editFields.name, imageUrl: editFields.imageUrl, link: '', shopeeProductUrl: urlKanonik(results.find((r) => r.sourceUrl === editUrl)?.data, editUrl) },
                );
                const F = (key, label, ph) => (
                    <div>
                        <label className="ish-fldl">{label}</label>
                        <input className="ish-in" value={editFields[key] || ''} onChange={(e) => setEditFields((p) => ({ ...p, [key]: e.target.value }))} placeholder={ph} />
                    </div>
                );
                return (
                    <div className="ish-editovl" onMouseDown={(e) => { if (e.target === e.currentTarget) setEditUrl(null); }}>
                        <div className="ish-editbox">
                            <div className="ish-edithead">
                                <div style={{ fontSize: 15, fontWeight: 800, color: 'var(--s-ink)' }}>{T('importShopee.edit.title', 'Edit data produk')}</div>
                                <div style={{ fontSize: 11, color: 'var(--s-ink-3)', marginTop: 2 }}>{T('importShopee.edit.hint', 'Nama, gambar dan description diperlukan untuk jadi READY.')}</div>
                            </div>
                            <div className="ish-editbody">
                                {F('name', T('import.edit.name', 'Nama Produk *'), '')}
                                {F('price', T('importShopee.edit.price', 'Harga'), 'cth: RM13.80')}
                                {F('originalPrice', T('import.edit.orig', 'Harga Asal'), 'cth: RM27.60')}
                                {F('discount', T('import.edit.disc', 'Diskaun %'), 'cth: -50%')}
                                {F('category', T('import.edit.cat', 'Kategori'), '')}
                                {F('imageUrl', T('importShopee.edit.img', 'Image URL *'), 'https://…')}
                                <div>
                                    <label className="ish-fldl">{T('import.edit.desc', 'Description *')}</label>
                                    <textarea className="ish-in" style={{ minHeight: 80, resize: 'vertical' }} rows={4} value={editFields.description || ''} onChange={(e) => setEditFields((p) => ({ ...p, description: e.target.value }))} placeholder={T('import.edit.descPh', 'Apa produk ni, kelebihannya, bahan, cara guna…')} />
                                </div>
                                <div>
                                    <label className="ish-fldl">{T('import.edit.spec', 'Specification')}</label>
                                    <textarea className="ish-in" style={{ minHeight: 60, resize: 'vertical' }} rows={3} value={editFields.specsText || ''} onChange={(e) => setEditFields((p) => ({ ...p, specsText: e.target.value }))} placeholder={'Bahan : Kapas\nSaiz : M, L, XL'} />
                                </div>
                                <div>
                                    <label className="ish-fldl">{T('import.edit.rev', 'Customer Reviews')}</label>
                                    <textarea className="ish-in" style={{ minHeight: 60, resize: 'vertical' }} rows={3} value={editFields.reviewsText || ''} onChange={(e) => setEditFields((p) => ({ ...p, reviewsText: e.target.value }))} />
                                </div>
                                <div style={{ background: prev.ready ? 'var(--s-ok-soft,var(--s-fill))' : 'var(--s-warn-soft,var(--s-fill))', border: `1px solid ${prev.ready ? 'var(--s-ok)' : 'var(--s-warn)'}`, borderRadius: 8, padding: '9px 11px' }}>
                                    <div style={{ fontSize: 12, fontWeight: 800, color: prev.ready ? 'var(--s-ok)' : 'var(--s-warn)' }}>
                                        {prev.ready ? T('importShopee.edit.ok', 'Cukup — produk ini akan jadi READY') : T('importShopee.edit.notReady', 'Belum cukup untuk READY')}
                                    </div>
                                    {!prev.ready && <div style={{ fontSize: 11, color: 'var(--s-ink-2)', marginTop: 3 }}>{T('import.card.stillNeed', 'Masih perlu')}: {prev.missing.join(', ')}</div>}
                                </div>
                            </div>
                            <div className="ish-editfoot">
                                <button className="ish-btn" onClick={() => setEditUrl(null)}>{T('import.cancel', 'Batal')}</button>
                                <button className="ish-btn ok" onClick={saveEdit}>{T('import.edit.save', 'Simpan')}</button>
                            </div>
                        </div>
                    </div>
                );
            })()}

            {rowToast && <div className="ish-toast">{rowToast}</div>}
        </div>
    );
}
